import { Component, OnInit, Input } from '@angular/core';
import { SaleItem } from '../../../data/sale-item';
import { MatDialog } from '@angular/material/dialog';
import { MobileSaleEditorComponent } from './mobile-sale-editor/mobile-sale-editor.component';

@Component({
    selector: 'app-mobile-sale-line',
    templateUrl: './mobile-sale-line.component.html',
    styleUrls: ['./mobile-sale-line.component.scss']
})
export class MobileSaleLineComponent implements OnInit {

    @Input()
    items: SaleItem[];

    @Input()
    qbServClasses = [];

    @Input()
    baseQbServClasses = [];

    queue = [];

    constructor(
        private dialog: MatDialog,
    ) { }

    ngOnInit(): void {
        if (this.items[this.items.length - 2]) {
            // tslint:disable-next-line: radix
            this.queue.push(parseInt(this.items[this.items.length - 2].id) + 1)
        }
    }

    openLineEditor(item: SaleItem) {
        const dialogRef = this.dialog.open(MobileSaleEditorComponent, {
            data: {
                item,
                // qbServClasses: this.qbServClasses,
                baseQbServClasses: this.baseQbServClasses
            },
            panelClass: ['sale-editor-modal-dialog', 'FULLSCREEN-DIALOG'],
            disableClose: false
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result[0] === 'Save') {
                console.log('saved')
                console.log(result[1])
            }
        });
    }



    addLines() {
        let temp
        if (this.items[this.items.length - 1] && typeof this.items[this.items.length - 1].id === 'undefined') {
            temp = this.items.pop();
        }

        this.queue.sort((a, b) => a - b);
        let tempId = this.queue.shift();

        if (this.queue.length === 0) {
            this.queue.push(tempId + 1);
        }

        tempId += ''

        const fitem = this.baseQbServClasses[1].find(item => item.fullyQualifiedName === 'Fabrication (retailing)');

        const tempItem = {
            id: tempId,
            description: `Manufacture and deliver cabinetry per proposal`,
            amount: 0,
            salesItemLineDetail: {
                itemRef: {
                    name: `Fabrication (retailing)`,
                    value: fitem.id
                },
                qty: 1,
                unitPrice: 0
            },
            detailType: 'SALES_ITEM_LINE_DETAIL'
        } as SaleItem

        if (this.items.length > 0) {
            const lastItem = this.items[0]
            if (lastItem.salesItemLineDetail && lastItem.salesItemLineDetail.classRef) {
                tempItem.salesItemLineDetail.classRef = lastItem.salesItemLineDetail.classRef
            }

        }

        this.items.push(tempItem)

        if (temp && temp.amount) {
            this.items.push(temp)
        }
    }


    deleteLine(idToDelete: string) {
        const index = this.items.findIndex(it => it.id === idToDelete)
        if (index > -1) {
            this.items.splice(index, 1);
        }

    }
}
